<template>
  <div class="homePage"
       :style="listHeight">
    <el-scrollbar class="scrollbar">
      <el-row class="logging"
              v-show="RecordList.length">
        <el-col>
          <div class="title">工作记录</div>
        </el-col>
        <el-col>
          <div class="main">
            <el-timeline>
              <el-timeline-item :timestamp="createTimeFormat(step.CREATETIME)"
                                color="#2b7cff"
                                placement="top"
                                v-for="(step,index) in RecordList"
                                :key="index">
                <el-card>
                  <h4 class="blueConent size14">{{step.NAME}}</h4>
                  <p class="blackConent2">[创建人:{{step.CREATEUSERNAME}}]&nbsp;[记录编号:{{step.INSTANCE}}]&nbsp;{{typeName(step)}}</p>
                  <p class="blackConent1"
                     v-html="step.INFO"></p>
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-col>
      </el-row>
      <el-row class="logging"
              v-show="DeviceArr.length>0">
        <el-col>
          <div class="title">设备</div>
        </el-col>
        <el-col>
          <div style="height:250px">
            <ayb-DeviceObjectList :idArray="DeviceArr"
                              @getValue="getTaskSelectedInstance"
                              @remoteClick="remoteClick"></ayb-DeviceObjectList>
          </div>
        </el-col>
      </el-row>
      <el-row class="taskProgress">
        <el-col>
          <div class="title">任务进度</div>
        </el-col>
        <el-col>
          <div class="main">
            <el-steps align-center
                      :active="active">
              <el-step v-for="(keyPath, index) in KeyPaths"
                       :key="index"
                       :title="keyPathTitle(keyPath)"
                       :description="keyPathDescription(keyPath)"></el-step>
            </el-steps>
          </div>
        </el-col>
      </el-row>
      <el-row class="content">
        <el-row class="title">
          <el-col :span="3">
            <div>任务名称：</div>
          </el-col>
          <el-col :span="21">
            {{task.TASKNAME}} &nbsp;&nbsp;
            <el-button v-show="task.CREATESOURCE == 10"
                       size="mini"
                       @click="EditTaskClick"
                       type="primary">编辑</el-button>
          </el-col>
        </el-row>
        <el-row v-if="mp3Url"
                class="title">
          <el-col :span="3">
            <div>电话录音:</div>
          </el-col>
          <el-col :span="21">
            <audio :src="mp3Url"
                   id="music"
                   controls="controls"></audio>
          </el-col>
        </el-row>
        <el-row v-if="mp3Url"
                class="title">
          <el-col :span="3">
            <div>来电电话:</div>
          </el-col>
          <el-col :span="9">{{phoneDetail.FORMPHONE}}</el-col>
          <el-col :span="3">
            <div>接听状态:</div>
          </el-col>
          <el-col :span="9">{{phoneDetail.ISANSWER?'已接':'未接'}}</el-col>
        </el-row>
        <el-row v-if="mp3Url"
                class="title">
          <el-col :span="3">
            <div>接听人员:</div>
          </el-col>
          <el-col :span="5">
            <ChatUser :userInfo="{id:phoneDetail.USERID,name:phoneDetail.USERNAME}"></ChatUser>
          </el-col>
          <el-col :span="3">
            <div>接听分机:</div>
          </el-col>
          <el-col :span="5">{{phoneDetail.TOPHONE}}</el-col>
          <el-col :span="3">
            <div>是否转接:</div>
          </el-col>
          <el-col :span="5">{{phoneDetail.ISTRANSFER}}</el-col>
        </el-row>
        <el-row class="title">
          <el-col :span="3">
            <div>联系人：</div>
          </el-col>
          <el-col :span="21">{{detail.LINKMANNAME}}</el-col>
        </el-row>
        <el-row class="title">
          <el-col :span="3">
            <div>创建人：</div>
          </el-col>
          <el-col :span="21">
            <ChatUser :userInfo="{id:task.CREATEUSERID,name:task.CREATEUSERNAME}"></ChatUser>
          </el-col>
        </el-row>
        <el-row class="title"
                v-if="detail.EVENTTYPENAME=='故障报修'">
          <el-col :span="3">
            <div class="title">故障地址：</div>
          </el-col>
          <el-col :span="21">{{detail.LINKADDRESS}}</el-col>
        </el-row>
        <el-row class="title">
          <el-col :span="3">
            <div class="title">附件下载：</div>
          </el-col>
          <el-col :span="21">
            <span v-for="(file, index) in fileList"
                  :key="index">
              <span class="fileList">{{file.FILENAME}}</span>
              <a @click="download(file.ID)">下载</a>
            </span>
          </el-col>
        </el-row>
        <el-row class="title">
          <el-col :span="3">
            <div class="title">操作超期：</div>
          </el-col>
          <el-col :span="21">{{(taskDetail.RESPONSEENDTIME||'').replace('T',' ').substr(0,19)}}</el-col>
        </el-row>
        <el-row class="title">
          <el-col :span="3">
            <div class="title">进度逾期：</div>
          </el-col>
          <el-col :span="21">{{(taskDetail.OVERTIME||'').replace('T',' ').substr(0,19)}}</el-col>
        </el-row>
        <el-row class="title">
          <el-col :span="3">
            <div class="title">内容描述：</div>
          </el-col>
          <el-col :span="21">
            <div v-html="taskContent.CONTENT"></div>
          </el-col>
        </el-row>
      </el-row>
      <!-- <el-row class="comment">
        <el-col>
          <div class="title">评论</div>
        </el-col>
        <el-col v-for="(data, index) in rootData" :key="index">
          <el-col>
            <div class="title1">
              <div class="name">{{data.CREATEUSERNAME}}</div>
              <div class="content">{{data.CONTENT}}</div>
              <div class="line"></div>
              <div class="commentText"></div>
              <div class="time">
                {{data.CREATETIME.replace("T"," ").replace("Z","").split(".")[0]}}
                <span
                  class="reply"
                  @click="reply(data)"
                >回复</span>
              </div>
              <div class="nameImg">
                <div
                  class="text"
                >{{data.CREATEUSERNAME.substring(data.CREATEUSERNAME.length-2,data.CREATEUSERNAME.length)}}</div>
              </div>
            </div>
          </el-col>
          <el-col
            v-for="(comment, index) in commentData.filter(item => item.ROOTID === data.ID)"
            :key="index"
          >
            <div class="title1">
              <div class="name">{{comment.TOUSERNAME}}</div>
              <div class="content">{{comment.CONTENT}}</div>
              <div class="line1"></div>
              <div class="commentText">回复：{{data.CREATEUSERNAME}}</div>
              <div
                class="time"
              >{{comment.CREATETIME.replace("T"," ").replace("Z","").split(".")[0]}}</div>
              <div class="nameImg">
                <div
                  class="text"
                >{{comment.CREATEUSERNAME.substring(comment.CREATEUSERNAME.length-2,comment.CREATEUSERNAME.length)}}</div>
              </div>
            </div>
          </el-col>
        </el-col>
        <el-col class="commitComment">
          <div class="contentArea">
            <el-input
              type="textarea"
              :autosize="{ minRows: 1, maxRows: 4}"
              :placeholder="contentPlaceholder"
              v-model="content"
              @keydown.ctrl.13.native="onSubmit"
              clearable
            ></el-input>
            <div class="button">
              <el-button size="mini" @click="onCancel">取消</el-button>
              <el-button type="primary" size="mini" @click="onSubmit">发送</el-button>
            </div>
          </div>
        </el-col>
      </el-row>-->
      <comment :MainId="task.ID"></comment>
    </el-scrollbar>
    <div class="ebutton">
      <el-button type="primary"
                 size="mini"
                 @click="onShowDialog"
                 icon="el-icon-circle-plus-outline">新增工作记录</el-button>
    </div>
    <side-tags-record-dialog ref="SideTagsRecordDialog"
                             pageType="2"></side-tags-record-dialog>
    <EditTaskDialog ref="EditTaskDialog"
                    :taskDetail="taskDetail"></EditTaskDialog>
  </div>
</template>

<script>
// import SideTagsRecordDialog from "./SideTagsRecordDialog.vue";
import ChatUser from "../Chat/ChatUser.vue";
import comment from "@/components/common/comment.vue";
import EditTaskDialog from "./EditTask.vue";
import { getToken } from "@/util/auth";
import tF from "@/util/timeFormat";
import { mapState } from "vuex";
import {
  GetRecordInfoByMainId,
  // GetAllTaskKeyPointsByTaskId,
  getEventByEventId,
  GetFileInfoByTaskId,
AddCrisitism,
GetCrisitismByMainId,
  GetTaskwandersByTaskId,
  GetTaskKeyPathByTaskId,
  GetPhoneDetail,
  getTaskByTaskId,
  GetTaskContentByTaskId,
  AddTaskKeyPoint
} from "@/api/modules/basicData/task";
import deviceApi from "@/api/modules/basicData/device";
export default {
  components: {
    // SideTagsRecordDialog,
    EditTaskDialog,
    ChatUser,
  },
  data() {
    return {
      mp3Url: "",
      deviceTimeList: [],
      RecordList: [],
      KeyPointsList: [],
      detail: {},
      fileList: [], //附件集合
      taskContent: [],
      sreplenishData: [], //评论集合
      rootData: [], //非回复集合
      commentData: [], //回复集合
      phoneDetail: {},
      content: "",
      contentPlaceholder: "评价内容(Crtl+Enter)",
      taskWanders: [],
      crisitisminfo: {},
      dialogFormVisible: false,
      KeyPaths: [],
      taskDetail: {},
      DeviceArr: [],
      DeviceList: []
    };
  },
  created() {
    let a = $(window).height();
    this.listHeight = "height:" + (a - 150) + "px;";
  },
  computed: {
    ...mapState({
      task: state => state.task.curTask,
      tabIndex: state => state.task.tabIndex
    }),
    active() {
      return this.KeyPaths ? this.KeyPaths.length : "";
    }
  },
  mounted() {
    this.initalTask();
  },
  methods: {
    remoteClick(item) {
      let deviceItem = this.deviceTimeList.filter(v => v.ID == item.ID);

      let isTrue = deviceItem.length == 0;
      if (!isTrue) {
        let dt = deviceItem[0].time;
        let dt1 = new Date(deviceItem[0].time);
        dt.setMinutes(dt.getMinutes() + 1);
        console.log(dt1, dt);

        isTrue = !tF.timeRange(dt1, dt);
      }

      if (isTrue) {
        const user = getToken();
        const typeList = [
          {
            name: "设备",
            value: 1
          },
          {
            name: "服务",
            value: 2
          },
          {
            name: "操作系统",
            value: 3
          },
          {
            name: "运用",
            value: 4
          },
          {
            name: "计算机",
            value: 5
          }
        ];
        AddTaskKeyPoint(
          this.task,
          user.realName +
            "远程了" +
            typeList.filter(v => v.value == item.Type)[0].name +
            item.IP
        );
      }
      let d = new Date();
      item.time = d;
      if (deviceItem.length == 0) {
        this.deviceTimeList.push(item);
      } else {
        let index = this.deviceTimeList.findIndex(p => p.ID == item.ID);
        this.$set(this.deviceTimeList, index, item);
      }
    },
    getTaskSelectedInstance(data, sourceData, type) {
      if (type != 0) {
        let deviceData = JSON.parse(JSON.stringify(sourceData));
        deviceData.forEach(c => {
          c.TASKID = this.task.ID;
          c.NAME = c.Name;
          c.DEVTYPENAME = c.ObjectTypeName;
          c.SOCIALID = c.SocialId;
          c.SOCIALTYPE = c.Type;
          c.OBJID = c.ObjectType;
          c.BRANDCODE = c.BrandCode;
          c.BRANDSHOWNAME = c.BrandName;
          c.SERIAL = c.Serial;
          c.MODE = c.Model;
          c.VERSION = c.Version;
          c.LOCATION =
            (c.Area || "") +
            (c.Building || "") +
            (c.Floor || "") +
            (c.RoomName || "");
          c.Id = 0;
        });
        console.log("UpdateTaskDevice", deviceData, this.DeviceList);

        deviceApi.UpdateTaskDevice(deviceData, this.DeviceList);
        setTimeout(() => {
          this.GetTaskDeviceByTaskId(this.task.ID);
        }, 1000);
      }
    },
    EditTaskClick() {
      this.$refs.EditTaskDialog.dialogVisible = true;
    },
    stop() {
      //关闭播放
      var audio = document.querySelector("#music");
      if (audio) {
        audio.pause();
      }
    },
    keyPathTitle(keyPath) {
      return keyPath ? keyPath.KEYPOINTNAME : "";
    },
    keyPathDescription(keyPath) {
      return keyPath
        ? keyPath.OPERATETIME.replace("T", " ")
            .replace("Z", "")
            .split(".")[0]
        : "";
    },
    onShowDialog() {
      this.$refs.SideTagsRecordDialog.dialogFormVisible = true;
      this.$refs.SideTagsRecordDialog.addRecordRelation(
        this.task.ID,
        this.task.TASKNAME,
        0,
        this.task.INSTANCE
      );
    },
    reply(data) {
      this.contentPlaceholder = "回复" + data.CREATEUSERNAME + "(Crtl+Enter)";
      this.crisitisminfo = data;
    },
    onCancel() {
      this.content = "";
      this.contentPlaceholder = "评价内容(Crtl+Enter)";
      this.crisitisminfo = {};
    },
    onSubmit() {
      if (!this.content) return;
      const date = new Date();
      const user = getToken();
      let par = {
        GUID: this.Guid(),
        CONTENT: this.content,
        CREATETIME: date,
        CREATEUSERID: user.userId,
        CREATEUSERNAME: user.realName,
        CREATEDEPTID: user.departmentId,
        CREATEDEPTNAME: "",
        MAINID: this.task.ID,
        MAINTYPE: 0,
        CREATECOMPANYID: user.organizationId,
        CREATECOMPANYNAME: ""
      };
      if (Object.keys(this.crisitisminfo).length > 0) {
        par.PID = this.crisitisminfo.ID;
        par.ROOTID = this.crisitisminfo.ID;
        par.TOUSERID = user.userId;
        par.TOUSERNAME = user.realName;
        par.TODEPTID = user.departmentId;
        par.TODEPTNAME = "";
        par.CREATEUSERNAME = this.crisitisminfo.CREATEUSERNAME;
      }
    AddCrisitism(par, true).then(pmevent => {
        if (pmevent === 1) {
          this.content = "";
          this.initalTask();
          this.$message({
            type: "success",
            message: "添加补充说明成功。"
          });
        } else {
          this.$message({
            type: "error",
            message: "添加补充说明失败！"
          });
        }
      });
    },
    Guid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    download(url) {
      window.location.href = url;
    },
    initalTask() {
      if (!this.task) return;
      if (this.task.ID) {
      GetCrisitismByMainId(this.task.ID, 0).then(pmevent => {
          if (!pmevent) return;
          this.sreplenishData = pmevent;
          this.rootData = pmevent.filter(item => item.ROOTID === null);
          this.commentData = pmevent.filter(item => item.ROOTID != null);
        });
        GetRecordInfoByMainId(this.task.ID, 0).then(pmevent => {
          if (!pmevent) return;
          this.RecordList = pmevent.splice(0, 2);
        });
        // 				GetAllTaskKeyPointsByTaskId(this.task.ID, 0).then(res => {
        // 					if (!res) return;
        // 					this.KeyPointsList = res
        // 				});
        GetTaskContentByTaskId(this.task.ID).then(pmevent => {
          this.taskContent = pmevent ? pmevent : {};
        });
        getEventByEventId(this.task.ID).then(pmevent => {
          this.detail = pmevent ? pmevent : {};
        });
        if (this.task.CREATESOURCE == 2) {
          GetPhoneDetail(this.task.EVENTID).then(pmevent => {
            this.phoneDetail = pmevent ? pmevent : {};
            this.mp3Url = pmevent
              ? this.Telephone_ROOT + pmevent.RECORDING
              : "";
            console.log("电话", this.mp3Url);
          });
        } else {
          this.phoneDetail = {};
          this.mp3Url = "";
        }
        GetFileInfoByTaskId(this.task.ID, 100).then(file => {
          file.forEach(c => {
            c.ID = this.IMGAPI_ROOT + "api/Task/DownloadFileById?id=" + c.ID;
          });
          this.fileList = file;
        });
        // 				GetTaskwandersByTaskId(this.task.ID).then(res => {
        // 					if (!res) return;
        // 					this.taskWanders = res;
        // 					console.log(res);
        // 				})
        GetTaskKeyPathByTaskId(this.task.ID).then(keyPath => {
          if (!keyPath) return;
          this.KeyPaths = keyPath;
          console.log(keyPath);
        });
        const user = getToken();
        getTaskByTaskId(this.task.ID, user.userId)
          .then(res => {
            this.taskDetail = res;
          })
          .catch(res => {
            console.log(res);
          });

        this.GetTaskDeviceByTaskId(this.task.ID);
      }
    },
    GetTaskDeviceByTaskId(taskID) {
      deviceApi
        .GetTaskDeviceByTaskId(this.task.ID)
        .then(res => {
          if (res) {
            this.DeviceList = res;
            this.DeviceArr = res.map(function(item) {
              return item.SOCIALTYPE + "_" + item.SOCIALID;
            });
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    taskWandersContent(index) {
      return this.taskWanders[index]
        ? this.taskWanders[index].SENDTIME.replace("T", " ")
            .replace("Z", "")
            .split(".")[0]
        : "";
    },
    createTimeFormat(time) {
      //格式化时间
      return time ? time.replace("T", " ").substr(0, 19) : "";
    },
    typeName(item) {
      const openName = item.ISOPEN ? "[公开]" : "[私人]";
      const typeName = item.RECORDTYPE === 0 ? "[个人]" : "[会议]";
      return typeName + openName;
    }
  },
  watch: {
    task(newvalue) {
      // alert(JSON.stringify(newvalue));
      if (!newvalue) return;
      this.initalTask();
    },
    tabIndex(newvalue) {
      if (!newvalue) return;
      this.initalTask();
    }
  }
};
</script>

<style lang="less" scoped>
@border-color: #d5dae6;
.homePage {
  box-sizing: border-box;
  .scrollbar {
    height: calc(100% - 40px);
    margin-top: 20px;

    .logging {
      .title {
        line-height: 60px;
        margin: 0 30px;
        border-bottom: 1px solid @border-color;
      }
      .main {
        margin: 0 30px;
        margin-top: 20px;
      }
    }
    .taskProgress {
      .title {
        line-height: 60px;
        margin: 0 30px;
        border-bottom: 1px solid @border-color;
      }
      .main {
        margin: 0 30px;
        margin-top: 20px;
        margin-bottom: 15px;
      }
    }
    .content {
      .title {
        line-height: 60px;
        margin: 0 30px;
      }
      .fileList {
        color: #2b7cff;
      }
      a {
        margin-right: 10px;
        font-size: 15px;
        color: #67c23a;
      }
    }
    .comment {
      .title {
        line-height: 60px;
        margin: 0 30px;
        border-bottom: 1px solid @border-color;
      }
      .title1 {
        // height: 95px;
        margin: 0 30px;
        border-bottom: 1px solid @border-color;
        box-sizing: border-box;
        .time {
          .reply {
            margin-left: 15px;
            color: #67c23a;
          }
        }
      }
      .nameImg {
        height: 40px;
        width: 40px;
        border-radius: 50%;
        background-color: #809cec;
        position: relative;
        // top: -85px;
        .text {
          position: relative;
          top: 8px;
          left: 5px;
          color: #fff;
        }
      }
      .name {
        margin-top: 5px;
        color: #2b7cff;
        margin-left: 50px;
      }
      .content {
        margin-left: 50px;
        width: 800px;
        font-size: 16px;
      }
      .line {
        height: 30px;
      }
      .line1 {
        height: 10%;
      }
      .commentText {
        margin-left: 50px;
        font-size: 14px;
        color: #929baa;
      }
      .time {
        margin-left: 50px;
        font-size: 14px;
        color: #929baa;
      }
    }

    .commitComment {
      margin-top: 20px;
      margin-bottom: 20px;
      .contentArea {
        margin: 0 30px;
      }
      .button {
        margin-top: 10px;
        float: right;
      }
    }
  }
  .ebutton {
    position: relative;
    left: 20px;
  }
}
</style>
<style scoped>
.homePage >>> .el-row {
  margin: auto;
  margin: 0px 20px 20px 20px;
  background-color: #fff;
}
.homePage >>> .el-col {
  margin-top: 0px;
}
.button .el-button {
  background: #ecf5ff;
  color: #0099ff;
}
</style>